import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { ColorClass, ModalService, OrderItem } from 'shared';
import { CollectingItemsService } from '../../collecting-items.service';

@Component({
    selector: 'app-product-location-map',
    templateUrl: './product-location-map.component.html',
    styleUrls: ['./product-location-map.component.scss'],
})
export class ProductLocationMapComponent implements OnInit {
    @Input() openedFromOrderItemDetails: boolean = false;
    @Input() orderItem: OrderItem;
    public fullSizeMap: boolean = false;
    public ColorClass = ColorClass;

    constructor(
        public modalService: ModalService,
        private _collectingItemsService: CollectingItemsService
    ) {}

    ngOnInit() {
        this.fullSizeMap = false;
    }
    public onClose(): void {
        if (this.openedFromOrderItemDetails)
            this._collectingItemsService.showOrderItemDetails(this.orderItem);
    }

    public openProductLocationMap(): void {
        this.modalService.setModalVisibility(
            true,
            'product-location-map' + this.orderItem.orderItemID
        );
    }

    public mapSizeChange(): void {
        this.fullSizeMap = !this.fullSizeMap;
    }
}
